import { Footer } from '../../../../components/engbers-specific/footer';
export const FooterTastic = ({
  data
}) => {
  return <Footer linkGroups={data.linkGroup} socialMediaGroups={data.links} logo={data.image?.media.file} data-sentry-element="Footer" data-sentry-component="FooterTastic" data-sentry-source-file="index.tsx" />;
};